<template lang="pug">
    g
        circle(:r="w/2",:cx="pos.x",:cy="pos.y",fill="white",stroke="white",opacity="0.7",stroke-width="1",v-show="map.highlighted")
        g(v-on:mouseup="stop_drag",v-on:mousedown="start_drag" :filter="filter" :opacity="opacity")
            circle(:r="1",:cx="pos.x",:cy="pos.y",fill="none",:stroke="locked_sextant_color",opacity="0.7",stroke-width="0.1" v-if="is_locked")
            g(@click.exact.stop='clicked' @mouseup.prevent='' @click.alt='shape' @click.shift='complete' @click.ctrl='alternate_sextant' @click.meta='alternate_sextant')
                image(ref='shaped' v-if='can_shape' :xlink:href="img(map.shaped_image)",:x="iconX",:y="iconY",:width="w",:height="h"  class='svg-pan-zoom-control')
                image(ref='normal' v-show='!map.shaped'  :xlink:href="img(map.image)",:x="iconX",:y="iconY",:width="w",:height="h"  class='svg-pan-zoom-control')
            text(:x='textX',:y='textY', text-anchor='middle', font-size="0.8" ,font-weight="bold",fill="white" ,stroke-width="0.02",stroke="black") {{map.name}}
</template>

<script>
    export default {
        name: "atlas-map"
        , props: {map: Object, pos: Object}
        , data() {
            return {
                w: 1.5,
                h: 1.5,
            }
        }
        , computed: {
            iconX() {
                return this.pos.x - this.w / 2;
            }
            , iconY() {
                return this.pos.y - this.h / 2;
            }
            , textX() {
                return this.pos.x;
            }
            , textY() {
                return this.pos.y - this.h / 2 - 0.3;
            }
            , can_shape() {
                return !this.map.unique && this.map.tier < 11 && this.map.shaped_image !== undefined;
            }
            , opacity() {
                return this.map.complete ? 1 : 0.3;
            }
            , filter() {
                return this.map.complete ? '' : 'filter="url(#grayscale)"';
            }
            , is_locked() {
                return this.map.locked_sextant > 0;
            }
            , locked_sextant_color() {
                let sextant_colors = ['yellow', 'rgba(46, 204, 113,1.0)', 'rgba(231, 76, 60,1.0)'];
                return sextant_colors[this.map.locked_sextant];
            }
        }
        , methods: {
            img(url) {
                return "//web.poecdn.com/image/Art/2DItems/Maps/" + url;
            }
            , clicked() {
                if (!this.$parent.$refs.menu.multiselect)
                    this.$parent.$refs.menu.clear_sextants(this.map);
                if (this.map.complete)
                    this.map.selected = !this.map.selected;
            }
            , shape() {
                if (this.can_shape)
                    this.map.shaped = !this.map.shaped;
            }
            , complete() {
                this.map.complete = !this.map.complete;

                if(!this.map.complete){
                    this.map.locked_sextant = 0;
                    this.map.selected = false;
                }
            }
            , start_drag() {
                this.$root.drag(this.map);
            }
            , stop_drag() {
                this.$root.drag(null);
            }
            , alternate_sextant() {
                if(!this.map.complete)
                    return;
                this.map.locked_sextant++;
                if (this.map.locked_sextant > 2)
                    this.map.locked_sextant = 0;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/AtlasMap.vue